export default __webpack_public_path__ + "static/media/branch-akjol.94dc6f25.png";